import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getExpireDate, getCurrentUser} from '../../functions/utils'; 
import { useTranslations  } from '../utilities/TranslationContext';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoaderComponent from '../utilities/LoaderComponent';

// Add the icons you will use to the library
library.add(faChevronDown, faXmark, faArrowLeft);
const JaarrekeningComponent = () => {
  const [isLoading, setIsLoading] = useState(false);  
  const [fvaiEmail, setFvaiEmail] = useState(false);  

  useEffect(() =>{
    init();
  },[]);

  // Handles the initial exact online setup
  async function init(){ 
    setIsLoading(true);
    const queryParams = new URLSearchParams(window.location.search);
    setFvaiEmail(queryParams.get('email'));
    console.log(queryParams.get('email'));
    clearQueryParams(['email']);
    window.location.href = 'https://factview.ai';
                
  }
 

  return (
    <div className="jaarrekening-container">
        <div className="body-loader"><div className="loader"></div></div>
    </div>
  );
}

export default JaarrekeningComponent;
